module.exports = __webpack_public_path__ + "static/img/QR.6a0f629.png";


//////////////////
// WEBPACK FOOTER
// ./static/moblieHome/QR.png
// module id = SQRi
// module chunks = 1